import React, { useState, useEffect, useContext } from "react";
import { Button, Form, Input, Layout, Row } from "antd";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import LoginPic from "../assets/images/finekralogo.png";
import RequestHandler from "util/RequestHandler";
import { useDispatch, useSelector } from "react-redux";
import { userSignIn } from "appRedux/actions/Auth";
import { Link } from "react-router-dom";
import paymentLogoBand from "../assets/images/payment-logo-band.png";
import { PageContext } from "./Context/PageContext";
const { Footer } = Layout;

const SignIn = (props) => {
  const dispatch = useDispatch();
  const token = useSelector(({ auth }) => {
    return auth.authUser;
  });

  const [loading, setLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState();
  const [isWithoutLoginPayment, setIsWithoutLoginPayment] = useState(false);
  const [panelLoginBannerImagePath, setPanelLoginBannerImagePath] = useState();
  const [panelLoginLogoImageUrl, setPanelLoginLogoImageUrl] = useState();
  const { setPageTitle } = useContext(PageContext);

  const onFinish = async (values) => {
    const domainUrl = localStorage.getItem("domainUrl");
    if (domainUrl) {
      values.b2BDomainUrl = domainUrl;
    }

    const response = await dispatch(userSignIn(values));
    if (!response?.success) {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => setLoading(false);

  useEffect(() => {
    let basePath = window.location.href.split("/signin")[0];
    let newLogoUrl = "";
    RequestHandler.get(
      `/FirmAuth/GetLoginEndpoints?domain=${encodeURIComponent(basePath)}`
    ).then((response) => {
      if (response?.success) {
        newLogoUrl = response?.data.logoUrl;
        if (response?.data?.tenantPaymentGuid !== "") {
          setIsWithoutLoginPayment(true);
        }
        localStorage.setItem("domainUrl", basePath);
        localStorage.setItem(
          "isTenantSelectedFromModal",
          response?.data?.isTenantSelectedFromModal
        );
        setPanelLoginBannerImagePath(
          response?.data?.b2BPanelLoginBannerImagePath
        );
        setPanelLoginLogoImageUrl(response?.data?.b2BPanelLoginBannerImageUrl);
        setPageTitle(response?.data?.pageTitle);
        localStorage.setItem("pageTitle", response?.data?.pageTitle);
      }

      if (newLogoUrl == "") {
        setLogoUrl(null);
      } else {
        setLogoUrl(newLogoUrl);
      }
    });
    if (token !== null) {
      props.history.push("/home");
    }
  }, [token, props.history]);

  return (
    <div className="gx-login-container">
      {panelLoginBannerImagePath && (
        <div className="gx-login-banner" style={{ height: "100vh" }}>
          {panelLoginLogoImageUrl ? (
            <a
              href={panelLoginLogoImageUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ height: "-webkit-fill-available" }}
            >
              <img
                src={panelLoginBannerImagePath}
                className="gx-banner-image"
                style={{ height: "-webkit-fill-available" }}
              />
            </a>
          ) : (
            <img
              src={panelLoginBannerImagePath}
              className="gx-banner-image"
              style={{ height: "-webkit-fill-available" }}
            />
          )}
        </div>
      )}

      <div className="gx-login-content">
        <div className="gx-login-header gx-text-center">
          <h1 className="gx-login-title">
            {logoUrl === undefined ? null : (
              <img
                src={logoUrl === null ? LoginPic : logoUrl}
                alt="paratic"
                title="paratic"
                style={{ marginBottom: "11%", width: "64%" }}
              />
            )}
          </h1>
        </div>
        <Form
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0"
        >
          <Form.Item
            rules={[{ required: true, message: "Email alanı zorunludur!" }]}
            name="email"
          >
            <Input prefix={<UserOutlined />} placeholder="Email" />
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Şifre alanı zorunludur!" }]}
            name="password"
          >
            <Input
              prefix={<LockOutlined />}
              type="password"
              placeholder="Şifre"
            />
          </Form.Item>
          <Link className="gx-login-form-forgot" to="/forget-password">
            Şifremi Unuttum
          </Link>
          <Form.Item className="gx-text-center">
            <Button
              onClick={() => setLoading(true)}
              loading={loading}
              type="primary"
              htmlType="submit"
              className="gx-login-button"
            >
              Giriş Yap
            </Button>
          </Form.Item>
          {isWithoutLoginPayment && (
            <Form.Item className="gx-text-center gx-without-login">
              <Link to="/pay-without-login">Üyeliksiz Ödeme</Link>
            </Form.Item>
          )}
        </Form>
        <Footer>
          <Row justify="space-between" align="middle">
            <div className="gx-layout-footer-content"></div>
            <div className="gx-layout-footer-content">
              <img
                src={paymentLogoBand}
                style={{ width: "100%", maxWidth: 450 }}
              />
            </div>
          </Row>
        </Footer>
      </div>
    </div>
  );
};

export default SignIn;
